import PageDetailCtrl from '../PageDetailCtrl';
import pageUrl from '../page.html';

export default {
  templateUrl: pageUrl,
  controller: PageDetailCtrl,
  controllerAs: 'ctrl',
  bindings: {
    pageId: '<',
  },
};
